'use strict';

require('./ReportByTask.scss');

const React = require('react'),
  DateUtils = require('utils/DateUtils'),
  {t} = require('services/i18nextWrapper'),
  InventoryStore = require('stores/InventoryStore'),
  {DatePicker, CircularProgress} = require('material-ui'),
  {cloneDeep} = require('lodash/lang'),
  FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton');

const ReportByTask = React.createClass({displayName: "ReportByTask",

  getInitialState() {
    return {
      filter: {
        moduleName: 'REPORT_BY_PRODUCT',
        isAllSelected: true,
        dateTo: new Date(),
        date: new Date(),
        isShowConfirmed: true,
        selectedTaskIds: [],
        reportKey: '',
        filterByOptionIndex: 0,
        isGeneratingReport: false
      }
    };
  },

  componentDidMount() {
  },

  onChangeFrom(nil, date) {
    this.setState(prevState => {
      prevState.filter.date = date;
      return prevState;
    });
  },

  _onSubmit() {
    let filter = cloneDeep(this.state.filter);
    filter.date = this.refs.date.getDate().toISOString();
    filter.reportKey = 'REPORT_BY_TASK_BY_DATE';
    this.setState({
      isGeneratingReport: true
    }, () => {
      InventoryStore.downloadReportXLS(filter, 'orders/by-tasks', () => {
        this.setState({isGeneratingReport: false, messageErrorItem: ''});
      });
    }, () => {
      Notification.show(t('dashboard_notification_something_was_wrong'), 'error');
    });
  },

  render() {
    const {date} = this.state.filter;
    const {isGeneratingReport} = this.state;

    return (
      React.createElement("div", {className: "report-by-beer-style"}, 
        React.createElement("div", {className: "report-by-beer-style__header"}, t('report_task_title')), 
        React.createElement("div", {className: "report-by-beer-style__body"}, 
          React.createElement("div", {className: "report-by-beer-style__body-row"}, 
            React.createElement("label", {style: {marginBottom: '8px'}, 
                   className: "report-by-beer-style__body-row-title"}, t('report_task_date')), 
            React.createElement(DatePicker, {
              ref: "date", 
              formatDate: DateUtils.toDateText, 
              style: {maxWidth: '200px', overflow: 'auto'}, 
              value: date, 
              onChange: this.onChangeFrom}
            )
          ), 
          React.createElement("div", {className: "report-by-beer-style__submit"}, 
            React.createElement(FormGroupButton, {
              className: "primary-icon", 
              type: "icon", 
              label: t('report_item_download_report'), 
              onClick: isGeneratingReport ? () => {} : this._onSubmit}
            ), 
            isGeneratingReport && React.createElement(CircularProgress, {size: .4})
          )
        )
      )
    );
  }
});

module.exports = ReportByTask;



/** WEBPACK FOOTER **
 ** ./src/views/ReportAdmin/ReportByTask/ReportByTask.jsx
 **/